function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
}

document.addEventListener('DOMContentLoaded', function () {
    /* ==========================================================================
       Sidebar
       ========================================================================== */
    if (typeof sidebarClass !== 'undefined') {
        const sidebarTogglerClass = `${sidebarClass}__toggler`;
        const sidebarTogglerButton = document.querySelector(`${sidebarClass} ${sidebarTogglerClass} button`);
        if (sidebarTogglerButton) {
            const sidebar = document.querySelector(sidebarClass);
            const sidebarToggler = sidebar.querySelector(sidebarTogglerClass);

            function toggleSidebar() {

                sidebarToggler.classList.toggle('toggled')
                sidebar.classList.toggle('toggled');

                if (getCookie('sidebar-toggled') === 'true') {
                    console.log('erase');
                    eraseCookie('sidebar-toggled');
                } else {
                    setCookie('sidebar-toggled', 'true', 7);
                }
            }

            sidebarTogglerButton.addEventListener('click', toggleSidebar);
        }
    }
});